import {generateSeoInfo} from '../../modules/seo/seoUtils';
import {PAGINATION_PARAM_NAMES} from '../../common/pagination/paginationConstants';

function generateDefaultInitialTagState() {
  return {
    tagSeoInfo: null,
    tagProductArray: null,
    tagBreadCrumbArray: null,
    tagProductPaginationParams: {
      pageNumber: 1,
    },
    totalTagProductCount: 0,
    tagSearchPass: null,
    tagSearchContext: null,
    isFetching: false,
    tagSeoRedirectionData: null,
    algKey: ''
  };
}

function tagReducer(state = generateDefaultInitialTagState(), action) {
  let newState;
  switch (action.type) {
    case 'GET_TAG_PRODUCTS': {
      newState = {
        ...state,
        isFetching: true
      }

      break;
    }
    case 'GET_TAG_PRODUCTS_FULFILLED': {
      const {
        products,
        breadcrumbs,
        totalProductCount,
        seoInformation: rawSeoInformation,
        searchPass,
        searchContext,
        townToTownEAD,
        cardType,
        al_g: algKey,
      } = action.payload.response.data.data;
      newState = {
        ...state,
        isFetching: false,
        tagProductArray: products,
        algKey,
        totalTagProductCount: totalProductCount,
        tagBreadcrumbArray: breadcrumbs,
        tagShippingType: generateSeoInfo(rawSeoInformation) ? generateSeoInfo(rawSeoInformation)?.utagData?.shipping_type : '',
        tagSeoInfo: generateSeoInfo(
          rawSeoInformation,
        ),
        tagSearchPass: searchPass,
        tagProductPaginationParams: {
          ...state.tagProductPaginationParams,
          ...action.triggerPayload.params,
          pageNumber:
            parseInt(action.triggerPayload.params[PAGINATION_PARAM_NAMES.PAGE], 10),
        },
        initialPageNumber: action.triggerPayload.params[PAGINATION_PARAM_NAMES.PAGE],
        tagSearchContext: searchContext,
        townToTownEAD,
        cardType,
      };

      break;
    }
    case 'GET_NEXT_TAG_PRODUCTS_FULFILLED': {
      const {
        products,
        totalProductCount,
        seoInformation: rawSeoInformation,
        townToTownEAD,
        cardType,
      } = action.payload.response.data.data;

      newState = {
        ...state,
        tagProductArray: state.tagProductArray.concat(
          products
        ),
        totalTagProductCount: totalProductCount,
        tagShippingType: state?.tagShippingType.concat(
          generateSeoInfo(rawSeoInformation) ? generateSeoInfo(rawSeoInformation)?.utagData?.shipping_type : '',
        ),
        tagSeoInfo: generateSeoInfo({
          ...rawSeoInformation,
          h2: state?.tagSeoInfo?.h2,
          seoParagraph: state?.tagSeoInfo?.seoParagraph,
        }),
        tagProductPaginationParams: {
          ...state.tagProductPaginationParams,
          ...action.triggerPayload.params,
          pageNumber:
            parseInt(action.triggerPayload.params[PAGINATION_PARAM_NAMES.PAGE], 10),
        },
        townToTownEAD,
        cardType,
      };

      break;
    }
    case 'LEAVE_TAG_PAGE_ROUTE': {
      newState = {
        ...state,
        tagProductArray: null,
        tagSeoInfo: null,
        tagProductPaginationParams: {
          pageNumber: 1,
        },
      };

      break;
    }
    case 'GET_TAG_PAGE_SEO_FULFILLED': {
      newState = {
        ...state,
        tagSeoRedirectionData: action?.payload?.response?.data?.data,
      };

      break;
    }
    default:
      newState = state;
  }

  return newState;
}

export default tagReducer;
export {generateDefaultInitialTagState};
